export const NOC_FIELDS = [
  'UserId',
  'Name',
  'Designation',
  'PassportNumber',
  'Reason',
  'TravelStartDate',
  'TravelEndDate',
  'TravelDestination',
  'Status',
  'DocumentNumber',
  'GeneratedHistories',
  'NocTypeId',
  'NocCopyType',
  'AppliedDateUtc',
  'ApprovedBy',
  'ApprovedByName',
  'ApprovedDateUtc',
  'ApprovalStatusReason',
  'DepartmentId',
  'Timezone',
  'LastUpdatedDate',
] as const;
